<template>
    <f7-page name="new-beneficiary" @page:beforein="beforein" @page:afterin="afterin" @page:afterout="afterout">
        <f7-navbar class="view-mobile no-border">
            <f7-nav-left class="back-button">
                <f7-link icon-f7="chevron_left" @click="backButton" color="black"></f7-link>
            </f7-nav-left>
            <f7-nav-right></f7-nav-right>
        </f7-navbar>

        <div class="block">
            <transition name="fade">
                <f7-card
                    class   ="alert alert-danger"
                    v-show  ="alertCard.show"
                >
                    <f7-card-header>
                        <span class="text-align-left" v-html="alertCard.title"></span>
                    </f7-card-header>
                    <i class="icon f7-icons card-close" @click="alertCard.show=false">xmark</i>
                </f7-card>
            </transition>

            <f7-row class="wandr-paragraph-1 vertical-margin">{{$t('beneficiary-recipient-details')}}</f7-row>

            <BeneficiarySelectCountry
                ref="selectCountryComponents"
                @resetFormData = "resetFormData"
                @loadTransactionTypeList="loadTransactionTypeList"
                @changeTransactionType = "changeTransactionType"
            />

            <BeneficiaryBillPayment v-if="showFormSet.billPayment"
                @changeBillCorp="changeBillCorp"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryBasic1
                @changeIdType="changeIdType"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <div v-if="showFormSet.bankTransfer">
                <BeneficiaryBTBeneficiaryType
                    @changeBeneficiaryType="changeBeneficiaryType"
                />

                <BeneficiaryBTBankName
                    :key="forceRerenderKey.componentBTBankNameKey"
                    @changeBank="changeBank"
                    @setInput="setInput"
                />

                <BeneficiaryBTBanKBranch
                    :key="forceRerenderKey.componentBTBankBranchKey"
                    @changeBankBranch="changeBankBranch"
                    @validateInput="validateInput"
                    @setInput="setInput"
                />

                <BeneficiaryBTDetails
                    @validateInput="validateInput"
                    @setInput="setInput"
                />

                <BeneficiaryBTIfsc
                    @validateInput="validateInput"
                    @setInput="setInput"
                />
            </div>

            <BeneficiaryCollection v-if="showFormSet.collection"
                :key="forceRerenderKey.componentCollectionKey"
                @changeCollectionAgent="changeCollectionAgent"
                @changeCollectionPoint="changeCollectionPoint"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryProvinceDetails v-if="showFormSet.provinceDetails"
                :key="forceRerenderKey.componentProvinceDetailsKey"
                @changeProvince="changeProvince"
                @changeCity="changeCity"
                @changeStreet="changeStreet"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryDoorToDoor v-if="showFormSet.doorToDoor || showFormSet.provinceDetails"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryBasic2
                @changePhilGovMemberType="changePhilGovMemberType"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <div v-if="showFormSet.kaasiDetails">
                <BeneficiaryAudBtAddress
                    @validateInput="validateInput"
                    @setInput="setInput"
                />
            </div>

            <BeneficiaryAudBtState v-if="showFormInput.kaasiDetails.state"
                :key="forceRerenderKey.componentAudBtStateKey"
                @changeProvince="changeProvince"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryAudBtSuburb v-if="showFormSet.kaasiDetails"
                :key="forceRerenderKey.componentAudBtSuburbKey"
                @changeCity="changeCity"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <div v-if="showFormSet.kaasiDetails">
                <BeneficiaryAudBtPoscode
                    @validateInput="validateInput"
                    @setInput="setInput"
                />
            </div>

            <BeneficiaryAudBtReceiverType v-if="showFormInput.kaasiDetails.radioButton"
                @changeBeneficiaryType="changeBeneficiaryType"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryAudBtBusiness v-if="showFormInput.kaasiDetails.auBusiness"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryNzBtBusiness v-if="showFormInput.kaasiDetails.nzBusiness"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryPaymentPurpose v-if="isShowPaymentPurpose"
                :key="forceRerenderKey.componentPaymentPurposeKey"
                @changePaymentPurpose="changePaymentPurpose"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryHomePhone v-if="isShowPhone"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryMobilePhone v-if="isShowPhone"
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryEmail
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <BeneficiaryAddressDetails
                @validateInput="validateInput"
                @setInput="setInput"
            />

            <f7-button @click="createNewRecipient" large fill :disabled="isFormInputValid ? false : true" class="view-desktop">
                {{$t('beneficiary-btn-add')}}
            </f7-button>
        </div>
        <f7-toolbar position="bottom" no-hairline class="toolbar-with-button view-mobile">
            <f7-button @click="createNewRecipient" large fill :disabled="isFormInputValid ? false : true">
                {{$t('beneficiary-btn-add')}}
            </f7-button>
        </f7-toolbar>

        <f7-sheet class="wandr-sheet-modal" :opened="daValidation.showSheet" @sheet:closed="daValidation.showSheet = false">
            <f7-page-content>
                <f7-block>
                    <f7-row class="mt-lg mb-md fs-18 fw-semibold text-color-black" id="daTitleLbl"></f7-row>
                    <p class="fs-14 fw-medium no-margin mb-xl text-color-gray" id="daDescLbl">-</p>
                    <div class="bg-color-gray3 card-20 mb-lg" style="border-radius: 10px">
                        <div class="text-color-gray fs-14 fw-medium">{{$t('beneficiary-da-current-name')}}</div>
                        <div class="regSuccess text-color-black fs-14 fw-bold" id="currentValue">-</div>
                        <div class="text-color-gray fs-14 fw-medium mt-md">{{$t('beneficiary-da-proposed-name')}}</div>
                        <div class="regSuccess text-color-black fs-14 fw-bold" id="proposedValue">-</div>
                    </div>
                    <f7-row>
                        <f7-col>
                            <f7-button large fill class="color-gray3 text-color-green" @click="validateDAChoice(1)" >{{$t('general-btn-no')}}</f7-button>
                        </f7-col>
                        <f7-col>
                            <f7-button large fill @click="validateDAChoice(2)">{{$t('general-btn-yes')}}</f7-button>
                        </f7-col>
                    </f7-row>
                </f7-block>
            </f7-page-content>
        </f7-sheet>
    </f7-page>
</template>

<script>
    import { mapGetters, mapActions } from "vuex";
    import BeneficiarySelectCountry from '../../components/beneficiary-select-country.vue';
    import store from '../../store';
    import addressDialogMixin from '../../plugins/address-dialog-mixin.js';

    export default {
        // DR-1845 code-inspection fix (Major) - showAddressRequiredAlert()/
        // confirmProceedWithoutAddress() were duplicated verbatim here and in
        // beneficiary-modify.vue; now shared via this mixin (see its own
        // comment for the full rationale).
        mixins: [addressDialogMixin],
        mounted() {
            // Required for everypage. Toggle desktop-view footer.
            this.toggleFooterVisibility(false)
            this.$f7.$('.page-content').on('scroll', (e) => {
                this.toggleFooterVisibility(e.target)
            })

            this.showAlert(false);
            // this.resetDataStore();
            this.loadCountry();
            this.init();
            this.hidePreloader();
        },
        data() {
            return {
                isDataFilled           : false,
                routerTo               : "",
                isShowPaymentPurpose   : true,
                isShowPhone            : false
            }
        },
        components: {
            BeneficiarySelectCountry,
            BeneficiaryBillPayment      : () => import('../../components/beneficiary-bill-payment.vue'),
            BeneficiaryBasic1           : () => import('../../components/beneficiary-basic-1.vue'),
            BeneficiaryBasic2           : () => import('../../components/beneficiary-basic-2.vue'),
            BeneficiaryBTBeneficiaryType: () => import('../../components/beneficiary-bt-beneficiary-type.vue'),
            BeneficiaryBTBankName       : () => import('../../components/beneficiary-bt-bank-name.vue'),
            BeneficiaryBTBanKBranch     : () => import('../../components/beneficiary-bt-bank-branch.vue'),
            BeneficiaryBTDetails        : () => import('../../components/beneficiary-bt-details.vue'),
            BeneficiaryBTIfsc           : () => import('../../components/beneficiary-bt-ifsc-code.vue'),
            BeneficiaryCollection       : () => import('../../components/beneficiary-collection.vue'),
            BeneficiaryProvinceDetails  : () => import('../../components/beneficiary-province-details.vue'),
            BeneficiaryDoorToDoor       : () => import('../../components/beneficiary-door-to-door.vue'),
            BeneficiaryAudBtAddress     : () => import('../../components/beneficiary-aud-bt-address.vue'),
            BeneficiaryAudBtPoscode     : () => import('../../components/beneficiary-aud-bt-postcode.vue'),
            BeneficiaryAudBtState       : () => import('../../components/beneficiary-aud-bt-state.vue'),
            BeneficiaryAudBtSuburb      : () => import('../../components/beneficiary-aud-bt-suburb.vue'),
            BeneficiaryAudBtReceiverType: () => import('../../components/beneficiary-aud-bt-receiver-type.vue'),
            BeneficiaryAudBtBusiness    : () => import('../../components/beneficiary-aud-bt-business.vue'),
            BeneficiaryNzBtBusiness     : () => import('../../components/beneficiary-nz-bt-business.vue'),
            BeneficiaryPaymentPurpose   : () => import('../../components/beneficiary-payment-purpose.vue'),
            BeneficiaryHomePhone        : () => import('../../components/beneficiary-home-phone.vue'),
            BeneficiaryMobilePhone      : () => import('../../components/beneficiary-mobile-phone.vue'),
            BeneficiaryEmail            : () => import('../../components/beneficiary-email.vue'),
            BeneficiaryAddressDetails   : () => import('../../components/beneficiary-address-details.vue'),
        },
        computed: {
            ...mapGetters('auth', [
                'authenticating',
                'authenticationError',
                'authenticationErrorCode',
                'authenticationSuccess'
            ]),
            ...mapGetters('beneficiary', [
                'homeCountryId',
                'homeCountryName',
                'homeCountryList',
                'hostCountryId',
                'hostCountryName',
                'transactionTypeList',
                'transactionTypeId',
                'transactionTypeName',
                'beneficiaryType',
                'beneficiaryTypeId',
                'bankNameLabel',
                'bankNamePlaceholder',
                'isbKashTx',
                'isDisplayErrorMsg',
                'radioErrorMsg',
                'identificationTypeLabel',
                'identificationNoLabel',
                'bankAccountNoLabel',
                'refNoLabel',
                'mobileNoLabel',
                'emailLabel',
                'streetLabel',
                'bankList',
                'bankBranchList',
                'beneficiaryNameLabel',
                'idTypeList',
                'bankId',
                'bankName',
                'bankBranchId',
                'bankBranch',
                'beneficiaryName',
                'bankAccountNo',
                'paymentPurpose',
                'paymentPurposeId',
                'paymentPurposeOther',
                'paymentPurposeList',
                'philGovMemberTypeList',
                'philGovMemberTypeId',
                'philGovMemberType',
                'bsbCode',
                'city',
                'cityId',
                'cityList',
                'collectionAgent',
                'collectionAgentId',
                'collectionAgentList',
                'collectionPoint',
                'collectionPointId',
                'collectionPointList',
                'billCorporationId',
                'billCorporationList',
                'billCorporationName',
                'billerCode',
                'countryCodeList',
                'province',
                'provinceId',
                'provinceList',
                'refNo',
                'street',
                'locatingNote',
                'landmark',
                'audAbn',
                'audAcn',
                'nzbn',
                'beneficiaryCountryId',
                'beneficiaryTownCity',
                'addressHardMandatory',
                'isAddressSectionInScope',
                'email',
                'homeIDD',
                'homeIDDCode',
                'homeNo',
                'mobileIDD',
                'mobileIDDCode',
                'mobileNo',
                'nickname',
                'identificationType',
                'identificationNo',
                'iban',
                'ifscCode',
                'ifscBankBranch',
                'sortCode',
                'swiftCode',
                'idTypeSelect',
                'idTypeSelectId',
                'dateOfBirth',
                'isFormInputValid',
                'validateInputState',
                'forceRerenderKey',
                'isCreateBeneficiary',
                'isSuburbSelected',
                'walletNo',

                'showFormSet',
                'showFormInput',
                'alertCard',
                'daValidation',
            ])
        },
        methods: {
            ...mapActions('auth', ['login']),
            ...mapActions('beneficiary', [
                'displayBillPayment', 'displayBankTransfer', 'displayCollection', 'displayProvinceDetails', 'displayDoorToDoor',
                'displayKaasiDetails', 'displayBillerCode', 'displayBank', 'displayBankBranch', 'displayBeneficiaryType',
                'displayBsbCode', 'displayIban', 'displayIfscCode', 'displaySortCode', 'displaySwiftCode', 'displayCity',
                'displayPostcode', 'displayProvince', 'displayBeneficiaryName', 'displayNickname', 'displayIdType',
                'displayIdTypeSelect', 'displayIdNo', 'displayAccountNo', 'displayCnIdNo', 'displayDateOfBirth',
                'displayPhilGovFullName', 'displayPhilGovNickname', 'displayPhilGovMemberType', 'displayRefNo', 'displayAudBtState',
                'displayAudRadio', 'displayAudBusiness', 'displayNzBusiness', 'displayPaymentPurpose', 'displayPaymentPurposeOther',
                'displayHomeNo', 'displayMobileNo', 'displayEmail',

                'changeStreetLabel',

                'validateBillCorp', 'validateBeneficiaryName', 'validateNickname', 'validateIdentificationType',
                'validateIdTypeSelect', 'validateIdentificationNo', 'validateBeneficiaryType', 'validateBank', 'validateBankBranch',
                'validateBsbCode', 'validateIban', 'validateSwiftCode', 'validateIfscCode', 'validateIfscBankBranch', 'validateSortCode',
                'validateCollectionAgent', 'validateCollectionPoint', 'validateProvince', 'validateCity', 'validateStreet',
                'validatePostcode', 'validateAccountNo', 'validateDOB', 'validatePhilGovMemberType', 'validateRefNote',
                'validateAbn', 'validateAcn', 'validateNzbn', 'validatePaymentPurpose', 'validateHomeNo', 'validateMobileNo',
                'validateEmail','validateLandmark', 'validateBeneficiaryCountry', 'validateBeneficiaryTownCity',

                'setHomeCountryList',
                'setTransactionTypeList',
                'setTransactionType',
                'setBeneficiaryCountry',
                'loadAddressConfig',
                'setBeneficiaryType',
                'setBankList',
                'setBank',
                'setBankBranch',
                'setBankBranchList',
                'setFormInputKaasiDetails',
                'setIdTypeList',
                'setIdTypeSelect',
                'setBankAccountNoLabel',
                'setEmailLabel',
                'setShowFormInputContactEmail',
                'setBankAccountNo',
                'setHostCountry',
                'setPaymentPurpose',
                'setPaymentPurposeOther',
                'setPaymentPurposeList',
                'setPhilGovMemberTypeList',
                'setPhilGovMemberType',
                'setCityList',
                'setCity',
                'setCollectionAgentList',
                'setCollectionAgent',
                'setCollectionPointList',
                'setCollectionPoint',
                'setBillCorp',
                'setBillerCode',
                'setBillCorporationList',
                'setCountryCodeList',
                'setProvinceList',
                'setProvince',
                'setStreet',
                'setStreetLabel',
                'setPostcode',
                'setLocatingNote',
                'setLandmark',
                'setRadioErrorMsg',
                'setHomeIDD',
                'setMobileIDD',
                'changePhilGovMemberType',
                'setBeneficiaryName',
                'setShowFormInputPaymentPurposeOther',
                'setIsDisplayErrorMsg',
                'changeHomePhoneCode',
                'changeMobilePhoneCode',
                'setIsFormInputValid',
                'setForceRerenderKey',
                'changeBank',
                'changeBankBranch',
                'setValidateInputState',
                'changeCollectionAgent',
                'changeCollectionPoint',
                'changeBeneficiaryType',
                'changeIdType',
                'changePaymentPurpose',
                'changeProvince',
                'changeCity',
                'changeStreet',
                'changeBillCorp',
                'setIsCreateBeneficiary',

                'resetFormData',
                'resetDataStore',
                'showHideInput',
                'validateInput',
                'resetBeneficiaryState',
                'finalValidatePostcode',
                'finalValidatePaymentPurpose',
                'finalValidateHomePhone',
                'finalValidateMobilePhone',
                'loadCityList',
                'loadPostCity',
                'changeDeliveryMethodToTransferType',
                'setNewBeneficiaryId',
                'setIsAutocomplete',
                'setIsDropdown'
            ]),

            async beforein(){
                this.showPreloader();
                this.resetBeneficiaryState();
            },

            afterout() {
                if(this.$f7.device.desktop && this.routerTo == 'emptyListFxCalc' && this.$f7router.url == '/sendmoney/select-beneficiary') {
                    this.backButton();
                }
            },

            afterin(){
                window.gtag('event', 'page_view', {page_title: 'Wandr-E [T] | '+this.$f7route.name, page_path: this.$f7route.path})
            },

            async loadCountry() {
                const self               = this;
                self.showPreloader();

                this.routerTo            = store.state.beneficiary.routerTo

                self.homeCountryList     = []
                const hostCountryPromise = await this.$api.beneficiary.getCountryDetails();

                const countryPromise     = await this.$api.beneficiary.getCountryList();

                const hostCountryDTO     = hostCountryPromise
                self.homeCountryList     = countryPromise
                self.setHomeCountryList(countryPromise);

                self.setHostCountry({id: hostCountryDTO.id, name: hostCountryDTO.name});

                if(this.routerTo == "emptyListFxCalc" || this.routerTo == "fxcalculator") {
                    this.$refs.selectCountryComponents.changeHomeCountry(store.state.transaction.homeCountryId)

                    if(store.state.transaction.deliveryMethodId != undefined) {
                        let params = {
                            countryId : this.homeCountryId,
                            dmId      : store.state.transaction.deliveryMethodId
                        }
                        this.changeDeliveryMethodToTransferType(params)
                    }
                }

                self.hidePreloader();
            },

            async loadTransactionTypeList(params) {
                const self = this;
                self.showPreloader();

                if(self.transactionTypeId != undefined) {
                    const ttPromise = await this.$api.beneficiary.getTransactionTypeList(this.homeCountryId);
                    const ttList    = ttPromise;

                    let txTypeList = [];
                    let sortTxType = "1,2,3,5,102,4,101,6";

                    let splitTxType = sortTxType.split(",");
                    for(let i = 0; i < splitTxType.length; i++) {
                        Object.keys(ttList).forEach(key => {
                            if(key == splitTxType[i]) {
                                if(key == 5 && this.homeCountryId == 18) {
                                    key = 103;
                                    ttList[key] = "";
                                }
                                txTypeList.push({key: key, value: this.$t('general-text-tt-' + key)})
                            }
                        })
                    }
                    // beneHelper.sortServiceTypeList(txTypeList);
                    self.setTransactionTypeList(txTypeList);

                    if(txTypeList.length == 1 && (this.transactionTypeId == '' || this.transactionTypeId == 0)) {
                        Object.keys(ttList).forEach(key => {
                            self.setTransactionType({id: key, name: ttList[key]});
                            this.setInputState("transactionType", true);
                        })
                    }
                }

                this.resetFormData(params);
                if(this.transactionTypeId > 0) {
                    this.changeTransactionType(this.transactionTypeId);
                }

                // DR-1845 - Beneficiary Country defaults to the destination country.
                // Must run here, after resetFormData() above (and the nested
                // changeTransactionType() -> resetFormData() when a transaction type
                // carries over) - both of those clear beneficiaryCountryId, so setting
                // the default any earlier (e.g. in changeHomeCountry) gets wiped out
                // by the time this function returns. Gated on isAddressSectionInScope
                // (awaiting a fresh loadAddressConfig first, since changeHomeCountry's
                // own call is fire-and-forget and may not have resolved yet) so this
                // never silently populates Beneficiary Country for corridors where the
                // section isn't shown at all (e.g. Indonesia) - same scope bug fixed in
                // beneficiary-modify.vue. Staff/customer can still override the default
                // via the Beneficiary Address Details section.
                if(this.homeCountryId > 0) {
                    await this.loadAddressConfig(this.homeCountryId);
                    if(this.isAddressSectionInScope) {
                        const country = this.homeCountryList.find(c => c.id == this.homeCountryId);
                        if(country) {
                            self.setBeneficiaryCountry({id: country.id, name: country.name});
                        }
                    }
                }

                self.hidePreloader();
            },

            changeTransactionType(ttId) {
                this.showAlert(false);

                let params = {
                    countryId : this.homeCountryId
                }
                this.resetFormData(params);

                for(let i = 0; i < this.transactionTypeList.length; i++) {
                    let thisDM = this.transactionTypeList[i]
                    if(thisDM.key == ttId) {
                        const ttName = this.$t('general-text-tt-' + ttId);
                        this.setTransactionType({id: ttId, name:  ttName});
                        break;
                    }
                }

                this.loadData(ttId);
            },

            async changeBeneficiaryType_(txTypeId) {
                const self       = this;
                var countryId    = this.homeCountryId;
                var beneTypeText = this.$t('beneficiary-other')

                if(txTypeId===1){
                    beneTypeText=this.$t('general-text-individual')
                }else{
                    beneTypeText=this.$t('general-text-corporate')
                }
                this.setBeneficiaryType({id: txTypeId, name: beneTypeText});

                let paymentPurposeListTmp = []
                if(this.transactionTypeId != 4 && this.transactionTypeId != 101) {
                    self.showPreloader();
                    let gender = store.state.customer.gender
                    if(gender.length<=0 || gender=== undefined){
                        gender ="M"
                    }
                    const purposePromise    = await this.$api.beneficiary.getPaymentPurposeList(countryId,gender, this.beneficiaryTypeId );
                    const ppList            = purposePromise

                    Object.keys(ppList).forEach(key => {
                        paymentPurposeListTmp.push({key: key, value: ppList[key]})
                    })

                    // NOT INDIA
                    if(this.homeCountryId != 98) {
                        paymentPurposeListTmp.push({key: -1, value: this.$t('beneficiary-other')})
                    }

                    self.setPaymentPurposeList(paymentPurposeListTmp);
                    self.setForceRerenderKey("paymentPurpose");
                    self.hidePreloader();
                    let ppIdTemp = 0;
                    let ppNameTemp = "";
                    self.setPaymentPurpose({id: ppIdTemp, name: ppNameTemp});
                }
                //console.log("test "+txTypeId)
            },

            async loadData(ttId) {
                const self = this;
                self.showPreloader();
                self.setIsCreateBeneficiary(true);

                // const branchPromise = await this.$api.beneficiary.getRetailBranchDetails();
                // const retailBranch  = branchPromise
                // var raId            = retailBranch.retailAgentId;
                var raId            = process.env.VUE_APP_RETAIL_AGENT_ID;
                var countryId       = this.homeCountryId;

                // 1 - BANK TRANSFER || 5 - CASH CARD || 101 - PHIL GOV SERVICE || 102 - WALLET || 103 - BKASH
                const emptyBankList = [];
                self.setBankList(emptyBankList);
                if(this.transactionTypeId == 1 || this.transactionTypeId == 5 || this.transactionTypeId == 101 || this.transactionTypeId == 102 || this.transactionTypeId == 103) {
                    const bankPromise = await this.$api.beneficiary.getBankList(raId, countryId, this.transactionTypeId);
                    self.setBankList(bankPromise);

                    const bList = Object.keys(self.bankList)
                    if(bList.length == 1) {
                        bList.forEach(key => {
                            self.setBank({id: key, name: self.bankList[key]});
                            this.setInputState("bankName", true);
                        })
                    }
                    if(bList.length > 10){ // USE AUTOCOMPLETE
                        self.setIsAutocomplete(true)
                    }else{
                        self.setIsAutocomplete(false)
                    }
                    this.changeBank(self.bankId);

                    // BANK TRANSFER && 106 - JAPAN
                    if(this.transactionTypeId == 1 && this.homeCountryId == 106){
                        self.setIsDropdown(true)
                    }else{
                        self.setIsDropdown(false)
                    }
                }

                // 3 - COLLECTION
                //self.collectionAgentList = [];
                // self.setCountryCodeList([]);
                if(this.transactionTypeId == 3) {
                    const colAgentPromise    = await this.$api.beneficiary.getCollectionAgentList(raId, countryId);
                    self.setCollectionAgentList(colAgentPromise)

                    const caList = Object.keys(self.collectionAgentList)
                    if(caList.length == 1) {
                        caList.forEach(key => {
                            self.setCollectionAgent({id: key, name: self.collectionAgentList[key]});
                            this.setInputState("collectionAgent", true);
                        })
                    }
                    this.changeCollectionAgent(self.collectionAgentId);

                    // 18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA
                    if(this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197) {
                        const idTypePromise = await this.$api.beneficiary.getBeneficiaryIdType();
                        self.setIdTypeList(idTypePromise);
                    }
                }

                // 2 - DOOR TO DOOR || (3 - COLLECTION && 167 - PHILIPPINES)
                // || 1 - BANK TRANSFER && (13 - AUSTRALIA || 106 - JAPAN || 152 - NEW ZEALAND)
                const emptyProvinceList = [];
                self.setProvinceList(emptyProvinceList);
                if(this.transactionTypeId == 2 || (this.transactionTypeId == 3 && this.homeCountryId == 167)
                    || (this.transactionTypeId == 1 && (this.homeCountryId == 13 || this.homeCountryId == 106 || this.homeCountryId == 152))
                ) {
                    const provincePromise = await this.$api.beneficiary.getProvinceList(countryId);
                    self.setProvinceList(provincePromise);
                    this.setForceRerenderKey("state");
                    this.setForceRerenderKey("suburb");

                    const pList = self.provinceList;
                    if(pList.length == 1) {
                        self.setProvince({id: pList[0].key, name: pList[0].value})
                        this.changeProvince(self.provinceId)
                    }
                }

                // NOT 4 - BILL PAYMENT && NOT 101 - PHIL GOV SERVICES
                let paymentPurposeListTmp = []
                if(this.transactionTypeId != 4 && this.transactionTypeId != 101) {
                    self.showPreloader();
                    let gender = store.state.customer.gender
                    if(gender.length<=0 || gender=== undefined){
                        gender ="M"
                    }
                    const purposePromise    = await this.$api.beneficiary.getPaymentPurposeList(countryId,gender, this.beneficiaryTypeId );
                    const ppList            = purposePromise

                    Object.keys(ppList).forEach(key => {
                        paymentPurposeListTmp.push({key: key, value: ppList[key]})
                    })

                    // NOT INDIA
                    if(this.homeCountryId != 98) {
                        paymentPurposeListTmp.push({key: -1, value: this.$t('beneficiary-other')})
                    }

                    self.setPaymentPurposeList(paymentPurposeListTmp);
                    self.setForceRerenderKey("paymentPurpose");
                }

                // 4 - BILL PAYMENT
                // const emptyBillCorporationList = [];
                // self.setBillCorporationList(emptyBillCorporationList);
                // if(this.transactionTypeId == 4) {
                //     const billCorpListPromise = await this.$api.beneficiary.getBillCorporationList(countryId);
                //     self.setBillCorporationList(billCorpListPromise);
                // }

                // const emptyCountryCodeList = [];
                // self.setCountryCodeList(emptyCountryCodeList);
                // const countryPromise = await this.$api.beneficiary.getCountryPhoneCodeList();
                // self.setCountryCodeList(countryPromise);
                self.isShowPhone = true;

                // if 236 - Vietnam (USD) set to 228 - Vietnam
                if(this.homeIDD == 236) {
                    this.homeIDD = 228
                }

                // if 236 - Vietnam (USD) set to 228 - Vietnam
                if(this.mobileIDD == 236) {
                    this.mobileIDD = 228
                }

                if(ttId > 0) {
                    this.showHideInput();
                }

                this.changeHomePhoneCode(this.homeIDD)
                this.changeMobilePhoneCode(this.mobileIDD)
                self.hidePreloader();
            },

            async init() {
                const self    = this;

                // HOME COUNTRY
                const popover      = ".beneficiary.popover-home-country";
                const popoverInner = ".beneficiary.popover-home-country .popover-inner";
                const popoverId    = "dropdownHomeCountry";
                const inputId      = "homeCountry";
                const inputListId  = "#homeCountryInput";
                await self.setDropdownDirection(popover, popoverInner, popoverId, inputId, inputListId)

                // TRANSFER TYPE
                const popover1      = ".beneficiary.popover-dropdown-tx-type";
                const popoverInner1 = ".beneficiary.popover-dropdown-tx-type .popover-inner";
                const popoverId1    = "dropdownTxType";
                const inputId1      = "transactionType";
                const inputListId1  = "#transactionInput";
                await self.setDropdownDirection(popover1, popoverInner1, popoverId1, inputId1, inputListId1)
            },

            setInput(inputEl){
                this.setInputState(inputEl, this.validateInputState.value)
            },

            finalValidateBeforeCreate() {
                this.setIsFormInputValid(false);
                let accountNumber = this.bankAccountNo
                const isWallet = this.transactionTypeId == 102 ? true : false
                if(isWallet){ accountNumber = /*this.mobileIDDCode.substring(1) +*/ this.walletNo }

                //console.log("add bene screen : isWallet ? "+isWallet+" ## "+accountNumber)

                let params = {
                    countryId : this.homeCountryId,
                    txTypeId  : this.transactionTypeId,
                    dmId      : -1,
                    bankId    : this.bankId,
                    bankTypeId: 0,
                    name      : this.beneficiaryName,
                    idType    : this.identificationType,
                    idNo      : this.identificationNo,
                    accountNo : accountNumber,
                    provinceId: this.provinceId,
                    cityId    : this.cityId,
                    postcode  : this.postcode,
                    refNo     : this.refNo,
                    ppId      : this.paymentPurposeId,
                    ppOther   : this.paymentPurposeOther,
                    homeNo    : this.homeNo,
                    homeIDD   : this.homeIDD,
                    mobileNo  : this.mobileNo,
                    mobileIDD : this.mobileIDD,
                    email     : this.email,
                }

                let beneficiaryState = store.state.beneficiary

                // BENEFICIARY NAME
                this.validateBeneficiaryName(params);
                let fullNameField = this.transactionTypeId == 101 ? "philGovServiceFullname" : "beneficiaryName";
                this.setInputState(fullNameField, beneficiaryState.isValidBeneficiaryName);
                let isFormInputValidTmp = beneficiaryState.isValidBeneficiaryName == true ? true : false;
                this.setIsFormInputValid(isFormInputValidTmp);
                if(!isFormInputValidTmp) {
                    return;
                }

                // NICKNAME
                this.validateNickname(this.nickname);
                let nicknameField = this.transactionTypeId == 101 ? "philGovServiceNickname" : "nickname";
                this.setInputState(nicknameField, beneficiaryState.isValidNickname);
                this.setIsFormInputValid(beneficiaryState.isValidNickname == true ? true : false);
                if(!this.isFormInputValid) {
                    return;
                }

                // NOT DOOR TO DOOR && NOT COLLECTION
                if(this.transactionTypeId != 2 && this.transactionTypeId != 3) {
                    // ACCOUNT NUMBER
                    this.validateAccountNo(params);
                    if(isWallet){
                        this.setInputState("walletNo", beneficiaryState.isValidWalletNo);
                        this.setIsFormInputValid(beneficiaryState.isValidWalletNo == true ? true : false);
                    }else{
                        this.setInputState("bankAccountNo", beneficiaryState.isValidAccountNo);
                        this.setIsFormInputValid(beneficiaryState.isValidAccountNo == true ? true : false);
                    }

                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // NOT BILL PAYMENT && NOT PHIL GOV SERVICE
                if(this.transactionTypeId != 4 && this.transactionTypeId != 101) {
                    // PURPOSE OF PAYMENT
                    let purposeField = this.paymentPurposeId == -1 ? "paymentPurposeOther" : "paymentPurpose";
                    Object.assign(params, {purposeField: purposeField});
                    this.finalValidatePaymentPurpose(params);
                    this.setInputState(purposeField, beneficiaryState.isValidPaymentPurpose);
                    this.setIsFormInputValid(beneficiaryState.isValidPaymentPurpose == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // NOT PHIL GOV SERVICE
                if(this.transactionTypeId != 101) {
                    // HOME NUMBER
                    this.finalValidateHomePhone(params);
                    this.setInputState("homeNo", beneficiaryState.isValidHomeNo);
                    this.setIsFormInputValid(beneficiaryState.isValidHomeNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // MOBILE NUMBER
                    this.finalValidateMobilePhone(params);
                    this.setInputState("mobileNo", beneficiaryState.isValidMobileNo);
                    this.setIsFormInputValid(beneficiaryState.isValidMobileNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // EMAIL
                this.validateEmail(params);
                this.setInputState("email", beneficiaryState.isValidEmail);
                this.setIsFormInputValid(beneficiaryState.isValidEmail == true ? true : false);
                if(!this.isFormInputValid) {
                    return;
                }

                // 1 - BANK TRANSFER || 5 - CASH CARD || 101 - PHIL GOV SERVICE || 102 - WALLET || 103 - BKASH
                if(this.transactionTypeId == 1 || this.transactionTypeId == 5 || this.transactionTypeId == 101 || this.transactionTypeId == 102 || this.transactionTypeId == 103) {
                    // (1 - BANK TRANSFER && (18 - BANGLADESH || 44 - CHINA || 95 - HONG KONG S.A.R. || 98 - INDIA || 99 - INDONESIA || 106 - JAPAN || 111 - S.KOREA || 128 - MALAYSIA
                    //         || 145 - MYANMAR || 148 - NEPAL || 161 - PAKISTAN || 167 - PHILIPPINES || 197 - SRI LANKA || 205 - TAIWAN || 208 - THAILAND || 221 - UNITED KINGDOM
                    //         || 222 - UNITED STATES  || 228 - VIETNAM || 236 - VIETNAM (USD) || 237 - CAMBODIA || 238 - EUROPEAN UNION (EU) || 253 - AMERICA))
                    // || 5 - CASH CARD || 101 - PHIL GOV SERVICE || 102 - WALLET || 103 - BKASH
                    if(this.transactionTypeId == 1 && (this.homeCountryId == 18 || this.homeCountryId == 44 || this.homeCountryId == 95 || this.homeCountryId == 98 || this.homeCountryId == 99
                            || this.homeCountryId == 106 || this.homeCountryId == 111 || this.homeCountryId == 128 || this.homeCountryId == 145 || this.homeCountryId == 148
                            || this.homeCountryId == 161 || this.homeCountryId == 167 || this.homeCountryId == 197 || this.countryId == 205 || this.homeCountryId == 208
                            || this.countryId == 221|| this.homeCountryId == 222 || this.homeCountryId == 228 || this.homeCountryId == 236 || this.homeCountryId == 237
                            || this.countryId == 238 || this.countryId == 253)
                        || this.transactionTypeId == 5 || this.transactionTypeId == 101 || this.transactionTypeId == 102 || this.transactionTypeId == 103
                    ) {
                        // BANK NAME
                        this.validateBank(params);
                        this.setInputState("bankName", beneficiaryState.isValidBank);
                        this.setIsFormInputValid(beneficiaryState.isValidBank == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // 101 - PHIL GOV SERVICE
                    if(this.transactionTypeId == 101) {
                        // PHIL GOV MEMBER TYPE
                        this.validatePhilGovMemberType(this.philGovMemberTypeId);
                        this.setInputState("philGovMemberType",  beneficiaryState.isValidPhilGovMemberType);
                        this.setIsFormInputValid(beneficiaryState.isValidPhilGovMemberType == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }
                    // 1 - BANK TRANSFER
                    else if(this.transactionTypeId == 1) {
                        // 18 - BANGLADESH || 44 - CHINA || 95 - HONG KONG S.A.R. || 106 - JAPAN || 111 - S.KOREA || 145 - MYANMAR || 148 - NEPAL
                        //     || 161 - PAKISTAN || 197 - SRI LANKA || 208 - THAILAND || 222 - UNITED STATES || 236 - VIETNAM (USD) || 237 - CAMBODIA
                        if(this.homeCountryId == 18 || this.homeCountryId == 44 || this.homeCountryId == 95 || this.homeCountryId == 106 || this.homeCountryId == 111
                            || this.homeCountryId == 145 || this.homeCountryId == 148 || this.homeCountryId == 161 || this.homeCountryId == 197 || this.homeCountryId == 208
                            || this.homeCountryId == 222 || this.homeCountryId == 236 || this.homeCountryId == 237
                        ) {
                            // BANK BRANCH
                            this.validateBankBranch(this.bankBranchId);
                            this.setInputState("bankBranch", beneficiaryState.isValidBankBranch);
                            this.setIsFormInputValid(beneficiaryState.isValidBankBranch == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // 44 - CHINA
                            if(this.homeCountryId == 44) {
                                // INDENTIFICATION NUMBER
                                this.validateIdentificationNo(params);
                                this.setInputState("cnIdentificationNo", beneficiaryState.isValidIdNo);
                                this.setIsFormInputValid(beneficiaryState.isValidIdNo == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // DATE OF BIRTH
                                this.validateDOB(this.dateOfBirth);
                                this.setInputState("dateOfBirth", beneficiaryState.isValidDateOfBirth);
                                this.setIsFormInputValid(beneficiaryState.isValidDateOfBirth == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }

                            // 106 - JAPAN
                            if(this.homeCountryId == 106){
                                // PROVINCE
                                this.validateProvince(this.provinceId);
                                this.setInputState("province", beneficiaryState.isValidProvince);
                                this.setIsFormInputValid(beneficiaryState.isValidProvince == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // CITY || DISTRICT
                                this.validateCity(this.cityId);
                                this.setInputState("city", beneficiaryState.isValidCity);
                                this.setIsFormInputValid(beneficiaryState.isValidCity == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // STREET
                                this.validateStreet(this.street);
                                this.setInputState("streetDropdown", beneficiaryState.isValidStreet);
                                this.setIsFormInputValid(beneficiaryState.isValidStreet == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // POSTCODE
                                Object.assign(params, {postcodeField: "postcode"});
                                this.finalValidatePostcode(params)
                                //console.log("POSTCODE : "+beneficiaryState.isValidPostcode.inputState)
                                this.setIsFormInputValid(beneficiaryState.isValidPostcode.inputState == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // LANDMARK
                                this.validateLandmark(this.landmark);
                                this.setInputState("landmark", beneficiaryState.isValidLandmark);
                                this.setIsFormInputValid(beneficiaryState.isValidLandmark == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }
                        }
                        // 13 - AUSTRALIA || 152 - NEW ZEALAND
                        else if(this.homeCountryId == 13 || this.homeCountryId == 152) {
                            // BSB CODE
                            const params = {bsbCode : this.bsbCode, countryId: this.homeCountryId}
                            this.validateBsbCode(params);
                            this.setInputState("bsbCode", beneficiaryState.isValidBsbcode);
                            this.setIsFormInputValid(beneficiaryState.isValidBsbcode == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // ADDRESS
                            this.validateStreet(this.street);
                            this.setInputState("address", beneficiaryState.isValidStreet);
                            this.setIsFormInputValid(beneficiaryState.isValidStreet == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // POSTCODE
                            Object.assign(params, {postcodeField: "kaasiPostcode"});
                            if(!this.isSuburbSelected){
                                this.finalValidatePostcode(params)
                            }
                            this.setIsFormInputValid(beneficiaryState.isValidPostcode.inputState == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // SUBURB
                            this.validateCity(this.cityId);
                            this.setInputState("suburb", beneficiaryState.isValidCity);
                            this.setIsFormInputValid(beneficiaryState.isValidCity == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // RECEIVER TYPE
                            this.validateBeneficiaryType(this.beneficiaryTypeId);
                            let radioErrorMsgTmp2     = beneficiaryState.isValidBeneficiaryType == true ? "" : beneficiaryState.isValidBeneficiaryType
                            this.setRadioErrorMsg(radioErrorMsgTmp2);
                            let tmpIsDisplayErrorMsg2 = beneficiaryState.isValidBeneficiaryType == true ? false : true
                            this.setIsDisplayErrorMsg(tmpIsDisplayErrorMsg2)
                            this.setInputState("beneficiaryType", beneficiaryState.isValidBeneficiaryType);
                            this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryType == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // 13 - AUSTRALIA
                            if(this.homeCountryId == 13) {
                                // STATE
                                this.validateProvince(this.provinceId);
                                this.setInputState("state", beneficiaryState.isValidProvince);
                                this.setIsFormInputValid(beneficiaryState.isValidProvince == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // 2 - BUSINESS
                                if(this.beneficiaryTypeId == 2) {
                                    // ABN
                                    this.validateAbn(this.audAbn);
                                    this.setInputState( "audAbn", beneficiaryState.isValidAbn);
                                    this.setIsFormInputValid(beneficiaryState.isValidAbn == true ? true : false);
                                    if(!this.isFormInputValid) {
                                        return;
                                    }

                                    // ACN
                                    this.validateAcn(this.audAcn);
                                    this.setInputState("audAcn", beneficiaryState.isValidAcn);
                                    this.setIsFormInputValid(beneficiaryState.isValidAcn == true ? true : false);
                                    if(!this.isFormInputValid) {
                                        return;
                                    }
                                }
                            }
                            // 152 - NEW ZEALAND
                            else if(this.homeCountryId == 152) {
                                // 2 - BUSINESS
                                if(this.beneficiaryTypeId == 2) {
                                    // NZBN
                                    this.validateNzbn(this.nzbn);
                                    this.setInputState("nzbn", beneficiaryState.isValidNzbn);
                                    this.setIsFormInputValid(beneficiaryState.isValidNzbn == true ? true : false);
                                    if(!this.isFormInputValid) {
                                        return;
                                    }
                                }
                            }
                        }
                        // 98 - INDIA
                        else if(this.homeCountryId == 98) {
                            // BENEFICIARY TYPE
                            this.validateBeneficiaryType(this.beneficiaryTypeId);
                            this.setInputState("beneficiaryType", beneficiaryState.isValidBeneficiaryType);
                            this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryType == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // IFSC CODE
                            this.validateIfscCode(this.ifscCode);
                            this.setInputState("ifscCode", beneficiaryState.isValidIfsccode);
                            this.setIsFormInputValid(beneficiaryState.isValidIfsccode == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // IFSC BANK BRANCH
                            if (this.showFormInput.bankTransfer.ifscBankBranch) {
                                this.validateIfscBankBranch(this.ifscBankBranch);
                                this.setInputState("ifscBankBranch", beneficiaryState.isValidIfscBankBranch);
                                this.setIsFormInputValid(beneficiaryState.isValidIfscBankBranch == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }

                                // Branch Name Notes
                                if (beneficiaryState.ifscBankBranch && beneficiaryState.ifscBankBranch.length > 0) {
                                    beneficiaryState.refNo = "IFSC Code: " + beneficiaryState.ifscCode + ", Branch name: " + beneficiaryState.ifscBankBranch + ";";
                                }
                            }
                        }
                        // 205 - TAIWAN
                        else if(this.homeCountryId == 205) {
                            // IDENTIFICATION NUMBER
                            this.validateIdentificationNo(params);
                            this.setInputState("identificationNo", beneficiaryState.isValidIdNo);
                            this.setIsFormInputValid(beneficiaryState.isValidIdNo == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                        // 221 - UNITED KINGDOM || 238 - EUROPEAN UNION (EU)
                        else if(this.homeCountryId == 221 || this.homeCountryId == 238) {
                            // IBAN
                            this.validateIban(this.iban);
                            this.setInputState("iban", beneficiaryState.isValidIban);
                            this.setIsFormInputValid(beneficiaryState.isValidIban == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }

                            // 221 - UNITED KINGDOM
                            if(this.homeCountryId == 221) {
                                // SORT CODE
                                this.validateSortCode(this.sortCode);
                                this.setInputState("sortCode", beneficiaryState.isValidSortcode);
                                this.setIsFormInputValid(beneficiaryState.isValidSortcode == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }
                            // 238 - EUROPEAN UNION (EU)
                            else if(this.homeCountryId == 238) {
                                // SWIFT CODE
                                this.validateSwiftCode(this.swiftCode);
                                this.setInputState("swiftCode", beneficiaryState.isValidSwiftcode);
                                this.setIsFormInputValid(beneficiaryState.isValidSwiftcode == true ? true : false);
                                if(!this.isFormInputValid) {
                                    return;
                                }
                            }
                        }
                        // 253 - AMERICA
                        else if(this.homeCountryId == 253) {
                            // SWIFT CODE
                            this.validateSwiftCode(this.swiftCode);
                            this.setInputState("swiftCode", beneficiaryState.isValidSwiftcode);
                            this.setIsFormInputValid(beneficiaryState.isValidSwiftcode == true ? true : false);
                            if(!this.isFormInputValid) {
                                return;
                            }
                        }
                    }
                }
                // 2 - DOOR TO DOOR || 3 - COLLECTION
                else if(this.transactionTypeId == 2 || this.transactionTypeId == 3) {
                    // IDENTIFICATION TYPE
                    // 3 - COLLECTION && (18 - BANGLADESH || 98 - INDIA || 197 - SRI LANKA (SELECT), OTHER TEXT)
                    if(this.transactionTypeId == 3
                            && (this.homeCountryId == 18 || this.homeCountryId == 98 || this.homeCountryId == 197)
                    ) {
                        this.validateIdTypeSelect(this.idTypeSelectId);
                        this.setInputState("idTypeSelect", beneficiaryState.isValidIdTypeSelect);
                        this.setIsFormInputValid(beneficiaryState.isValidIdTypeSelect == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    } else {
                        this.validateIdentificationType(params);
                        this.setInputState("identificationType", beneficiaryState.isValidIdType);
                        this.setIsFormInputValid(beneficiaryState.isValidIdType == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // IDENTIFICATION NUMBER
                    this.validateIdentificationNo(params);
                    this.setInputState("identificationNo", beneficiaryState.isValidIdNo);
                    this.setIsFormInputValid(beneficiaryState.isValidIdNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // REF NO
                    this.validateRefNote(params);
                    this.setInputState("refNo", beneficiaryState.isValidRefNo);
                    this.setIsFormInputValid(beneficiaryState.isValidRefNo == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // 2 - DOOR TO DOOR || (3 - COLLECTION && (167 - PHILIPPINES && (1104 - BDO/RURAL BANK/SM FOREX || 2200 - PALAWAN PAWNSHOP))
                    if(this.transactionTypeId == 2
                        || (this.transactionTypeId == 3 && (this.homeCountryId == 167 && (this.collectionAgentId == 1104 || this.collectionAgentId == 2200)))
                    ) {
                        // PROVINCE
                        this.validateProvince(this.provinceId);
                        this.setInputState("province", beneficiaryState.isValidProvince);
                        this.setIsFormInputValid(beneficiaryState.isValidProvince == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }

                        // CITY
                        this.validateCity(this.cityId);
                        this.setInputState("city", beneficiaryState.isValidCity);
                        this.setIsFormInputValid(beneficiaryState.isValidCity == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }

                        // POSTCODE
                        Object.assign(params, {postcodeField: "postcode"});
                        this.finalValidatePostcode(params)
                        this.setIsFormInputValid(beneficiaryState.isValidPostcode.inputState == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // 2 - DOOR TO DOOR || (3 - COLLECTION && (99 - INDONESIA || (167 - PHILIPPINES && (1104 - BDO/RURAL BANK/SM FOREX || 2200 - PALAWAN PAWNSHOP)))
                    if(this.transactionTypeId == 2
                        || (this.transactionTypeId == 3
                                && (this.homeCountryId == 99 || (this.homeCountryId == 167 && (this.collectionAgentId == 1104 || this.collectionAgentId == 2200)))
                            )
                    ) {
                        // STREET
                        this.validateStreet(this.street);
                        this.setInputState("street", beneficiaryState.isValidStreet);
                        this.setIsFormInputValid(beneficiaryState.isValidStreet == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }

                    // 3 - COLLECTION
                    if(this.transactionTypeId == 3) {
                        // COLLECTION AGENT
                        this.validateCollectionAgent(this.collectionAgentId);
                        this.setInputState("collectionAgent", beneficiaryState.isValidCollectionAgent);
                        this.setIsFormInputValid(beneficiaryState.isValidCollectionAgent == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }

                        // COLLECTION POINT
                        this.validateCollectionPoint(this.collectionPointId);
                        this.setInputState("collectionPoint", beneficiaryState.isValidCollectionPoint);
                        this.setIsFormInputValid(beneficiaryState.isValidCollectionPoint == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }
                }
                // 4 - BILL PAYMENT
                else if(this.transactionTypeId == 4) {
                    // BILL CORPORATION
                    this.validateBillCorp(this.billCorporationId);
                    this.setInputState("billCorp", beneficiaryState.isValidBillCorp);
                    this.setIsFormInputValid(beneficiaryState.isValidBillCorp == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }

                    // 167 - PHILIPPINES && REF NO
                    if(this.homeCountryId == 167) {
                        // REF NO
                        this.validateRefNote(params);
                        this.setInputState("refNo", beneficiaryState.isValidRefNo);
                        this.setIsFormInputValid(beneficiaryState.isValidRefNo == true ? true : false);
                        if(!this.isFormInputValid) {
                            return;
                        }
                    }
                }
                // 6 - UPI
                else if(this.transactionTypeId == 6) {
                    // BENEFICIARY TYPE
                    this.validateBeneficiaryType(this.beneficiaryTypeId);
                    this.setInputState("beneficiaryType", beneficiaryState.isValidBeneficiaryType);
                    this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryType == true ? true : false);
                    if(!this.isFormInputValid) {
                        return;
                    }
                }

                // DR-1845 - BENEFICIARY COUNTRY / TOWN-CITY (only blocks when hard
                // mandatory for this destination country; soft/optional otherwise).
                // Both are validated together (rather than stopping at the first
                // invalid one) so the hard-required popup below can cover "country
                // and city" collectively, matching its wording - same combined
                // treatment retail uses for its own soft-mode message.
                this.validateBeneficiaryCountry(this.beneficiaryCountryId);
                this.setInputState("beneficiaryCountryId", beneficiaryState.isValidBeneficiaryCountry);

                this.validateBeneficiaryTownCity(this.beneficiaryTownCity);
                this.setInputState("beneficiaryTownCity", beneficiaryState.isValidBeneficiaryTownCity);

                this.setIsFormInputValid(beneficiaryState.isValidBeneficiaryCountry == true
                    && beneficiaryState.isValidBeneficiaryTownCity == true);
                if(!this.isFormInputValid) {
                    this.showAddressRequiredAlert();
                    return;
                }

                return this.isFormInputValid;
            },

            // DR-1845 code-inspection fix (Major) - showAddressRequiredAlert() and
            // confirmProceedWithoutAddress() moved to plugins/address-dialog-mixin.js
            // (mixed in above) - were duplicated verbatim here and in
            // beneficiary-modify.vue.

            validateDAChoice(value) {
                if(value == 2) { // yes
                    this.setBeneficiaryName(this.daValidation.proposedResult);
                } else {
                    this.daValidation.skipValidation = true;
                }
                this.daValidation.showSheet = false;
                this.createNewRecipient();
            },

            async createNewRecipient() {
                this.showPreloader();
                this.setIsFormInputValid(false);
                this.showAlert(false);
                if(!this.finalValidateBeforeCreate()) {
                    this.hidePreloader();
                    return;
                }

                // DR-1845 - soft-mandatory mode: the global toggle is off, so
                // finalValidateBeforeCreate() above never blocks on a blank
                // Beneficiary Country/Town-City even when this destination wants
                // it - confirm with the customer/agent before proceeding, same as
                // retail's CreateRemittance.jsp doSubmit() confirm() popup.
                this.hidePreloader();
                if(!(await this.confirmProceedWithoutAddress())) {
                    return;
                }
                this.showPreloader();

                //this.resetDataStore();
                let newBeneficiaryData          = store.state.beneficiary;
                newBeneficiaryData.isDataFilled = true;

                // WS validation
                const validateInput = await this.$api.beneficiary.validateBeneInput(newBeneficiaryData, true);
                if(validateInput.invalid) {
                    this.showAlert("true", validateInput.errTitle);
                    this.setInputState(validateInput.inputField, this.$t(validateInput.errMsg, { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}));
                    this.setIsFormInputValid(false);

                    this.hidePreloader();
                    return;
                } else if(!validateInput.result.isValid && validateInput.result.daResultCode == 1758 && !this.daValidation.skipValidation) {
                    this.daValidation.showSheet = true;
                    this.daValidation.proposedResult = validateInput.result.proposedResult;

                    var $$ = this.Dom7;
                    $$("#currentValue").text(this.beneficiaryName);
                    $$("#proposedValue").text(this.daValidation.proposedResult);
                    // $$("#daTitleLbl").text(this.$t(validateInput.result.message));
                    $$("#daDescLbl").text(this.$t(validateInput.result.message + "-desc"));

                    this.hidePreloader();
                    return;
                }

                // WS validation success then create bene
                if(!validateInput.invalid) {
                    this.showPreloader();
                    const newBeneficiary = await this.$api.beneficiary.createBeneficiary(newBeneficiaryData);

                    if(newBeneficiary.invalid) {
                        this.showAlert(true, this.$t(newBeneficiary.message));
                    } else if(newBeneficiary.status == '0400') { // success
                        if( this.routerTo == "sendMoney" || this.routerTo == "fxcalculator" || this.routerTo == "emptyListFxCalc" ){
                            this.$store.state.beneficiary.routerTo = (this.routerTo == "fxcalculator" || this.routerTo == "emptyListFxCalc") ? "fxcalculator" : "";
                        }else{
                            this.$store.state.beneficiary.routerTo = "beneficiaryCreated"
                        }

                        this.resetDataStore({isNewHomeCountry: true});

                        // GET HOME COUNTRY LIST
                        const homeCountryPromise     = await this.$api.beneficiary.getCountryList();
                        this.setHomeCountryList(homeCountryPromise);

                        this.setNewBeneficiaryId(newBeneficiary.result.id);
                        this.$f7router.navigate("/beneficiary-details");
                    } else if(newBeneficiary.status == '0402') {
                        this.showAlert(true, this.$t('beneficiary-ws-general-error-desc', { zoholink:  process.env.VUE_APP_CUSTOMER_SERVICE_ZOHO_LINK}))
                        //this.showAlert(true, this.$t(newBeneficiary.message));
                        //this.setInputState("bankAccountNo", this.$t('beneficiary-bank-account-no-error'))
                        //this.setInputState("walletNo", this.$t('beneficiary-mobile-no-error'))
                    } else {
                        this.showAlert(true, this.$t('beneficiary-ws-general-error'));
                    }
                }
                this.hidePreloader();
            },

            showAlert(status, title, content) {
                this.alertCard.show = status;
                if(title == undefined) {
                    title = "";
                } else {
                    title = this.$t(title);
                }

                if(content == undefined) {
                    content = "";
                } else {
                    content = this.$t(content);
                }
                this.alertCard.title   = title;
                this.alertCard.content = content;
            },

            backButton() {
                this.showAlert(false);
                this.resetFormData();
                this.resetDataStore({isNewHomeCountry: true});
                switch(this.routerTo) {
                    case "beneList" :
                        this.$f7router.navigate("/beneficiary-list")
                        break
                    case "emptyList" :
                        this.$f7router.navigate("/home")
                        break
                    case "emptyListFxCalc" :
                        this.$store.state.beneficiary.routerTo = "emptyListFxCalc"
                        this.$f7router.back("/exchangerate",{force:true})
                        break
                    case "fxcalculator" :
                        this.$store.state.beneficiary.routerTo = "fxcalculator"
                        this.$f7router.back()
                        break
                    case "sendMoney" :
                        this.$f7router.navigate("/sendmoney/select-beneficiary")
                        break
                    default :
                        this.$f7router.navigate("/beneficiary-list")
                        break
                }
            }
        }
    }
</script>